export default function Footer () {
  return (
    <div className="footer">©2022 Tool Swap</div>
  )
}